import * as React from "react";
import {
    GridColumnMenuContainer,
    GridColumnMenuProps,
    SortGridMenuItems,
    GridFilterMenuItem,
    HideGridColMenuItem,
    GridColumnsMenuItem,
} from "@mui/x-data-grid-pro";
import { Box, MenuItem, Popover, TextField } from "@mui/material";
import CclButton from "../../../../components/common/cclButtons/cclButton";

export type CustomColumnMenuProps = GridColumnMenuProps & {
    fillColumn: (columnKey: string, value: any) => void;
};

const CustomColumnMenu: React.FC<CustomColumnMenuProps> = (props: CustomColumnMenuProps) => {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const [inputValue, setInputValue] = React.useState("");
    const [hideArg, setHideArg] = React.useState<React.SyntheticEvent<Element, Event> | null>(null);

    const handleMenuClick = (event: React.MouseEvent<HTMLElement>) => {
        setHideArg(event);
        setAnchorEl(event.currentTarget);
    };

    const handleCancel = () => {
        setAnchorEl(null);
        setInputValue("");
        props.hideMenu(hideArg as React.SyntheticEvent<Element, Event>);
    };

    const handleOk = () => {
        props.fillColumn(props.currentColumn.field, inputValue);
        setAnchorEl(null);
        setInputValue("");
        props.hideMenu(hideArg as React.SyntheticEvent<Element, Event>);
    };

    return (
        <>
            <GridColumnMenuContainer {...props}>
                <SortGridMenuItems onClick={props.hideMenu} column={props.currentColumn} />
                <GridFilterMenuItem onClick={props.hideMenu} column={props.currentColumn} />
                <HideGridColMenuItem onClick={props.hideMenu} column={props.currentColumn} />
                <GridColumnsMenuItem onClick={props.hideMenu} column={props.currentColumn} />
                <MenuItem onClick={handleMenuClick}>Fill Column</MenuItem>
            </GridColumnMenuContainer>
            <Popover
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                onClose={handleCancel}
                anchorOrigin={{ vertical: "center", horizontal: "right" }}
                transformOrigin={{ vertical: "center", horizontal: "left" }}
            >
                <Box display="flex" alignItems="center" p={2} gap={1}>
                    <TextField
                        size="small"
                        value={inputValue}
                        onChange={(e) => setInputValue(e.target.value)}
                        placeholder="Enter value"
                        autoFocus
                        sx={{ width: 300 }}
                    />
                    <CclButton size="small" onClick={handleOk} mode={"primary"}>
                        OK
                    </CclButton>
                    <CclButton mode="secondary" size="small" onClick={handleCancel}>
                        Cancel
                    </CclButton>
                </Box>
            </Popover>{" "}
        </>
    );
};

export default CustomColumnMenu;
